var _symbol, _symbol2, _symbol3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse",
    viewBox: "0 0 23 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.588 11.96c0 6.085-5.057 19.099-11.294 19.099s-11.294-13.014-11.294-19.099c0-6.085 5.057-11.019 11.294-11.019s11.294 4.933 11.294 11.019z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-paint",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    opacity: 0.5,
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M29.294 16c0 7.342-5.952 13.293-13.293 13.293s-13.293-5.952-13.293-13.293c0-7.342 5.952-13.293 13.293-13.293s13.293 5.952 13.293 13.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    style: {
      stroke: "var(--color2, #000)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M10.789 19.657l3.501 3.501 3.112-3.112c0.051-0.051 0.112-0.092 0.178-0.119s0.138-0.042 0.21-0.042c0.072 0 0.144 0.014 0.21 0.042s0.127 0.068 0.178 0.119M10.789 19.657l-1.945-1.945 3.112-3.112c0.051-0.051 0.092-0.112 0.119-0.178s0.042-0.138 0.042-0.21c0-0.072-0.014-0.144-0.042-0.211s-0.068-0.127-0.119-0.178M10.789 19.657l1.556-1.556M18.18 20.046c0.051 0.051 0.112 0.092 0.178 0.119s0.138 0.042 0.211 0.042 0.144-0.014 0.21-0.042c0.067-0.028 0.127-0.068 0.178-0.119l1.784-1.784c0.146-0.146 0.228-0.344 0.228-0.55s-0.082-0.404-0.228-0.55l-1.623-1.623c-0.146-0.146-0.228-0.344-0.228-0.55s0.082-0.404 0.228-0.55l2.79-2.79c0.146-0.146 0.228-0.344 0.228-0.55s-0.082-0.404-0.228-0.55l-0.456-0.456c-0.146-0.146-0.344-0.228-0.55-0.228s-0.404 0.082-0.55 0.228l-2.79 2.79c-0.146 0.146-0.344 0.228-0.55 0.228s-0.404-0.082-0.55-0.228l-1.623-1.623c-0.146-0.146-0.344-0.228-0.55-0.228s-0.404 0.082-0.55 0.228l-1.784 1.784c-0.051 0.051-0.092 0.112-0.119 0.178s-0.042 0.138-0.042 0.21c0 0.072 0.014 0.144 0.042 0.21s0.068 0.127 0.119 0.178M18.18 20.046l-6.224-6.224"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.554 17.991l9.815 9.739-2.568 2.588-14.232-14.123 14.123-14.232 2.588 2.568-9.739 9.815 22.186-0.086 0.014 3.645-22.186 0.086z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lens",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#626262",
    style: {
      stroke: "var(--color3, #626262)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.7778,
    d: "M23.384 23.334l6.839 6.888M27.062 14.42c0 6.982-5.66 12.642-12.642 12.642s-12.642-5.66-12.642-12.642c0-6.982 5.66-12.642 12.642-12.642s12.642 5.66 12.642 12.642z"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 0h2.667v32h-2.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.010 14.663l0.007 2.659-32.009 0.084-0.007-2.659 32.009-0.084z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.9a6a1f5ea112f4993e50fcba55a1e6ac.svg";
export { ForwardRef as ReactComponent };